<template>
  <div id="cultrue">
    <div class="cbox">
      <div>
        <img src="~@/common/img/cultrue.jpg">
      </div>
      <div>
        <div class="box">
          <div class="tit">管理理念</div>
          <div class="info" style="margin:0">关心员工成长；为员工提供良好的工作环境和激励机制；完善员工培养体系和职业发展通道，使员工获得与企业同步成长的喜悦；充分尊重和信任员工，不断引导和鼓励，使其获取成就的喜悦。</div>
        </div>
        <div class="box">
          <div class="tit">人才观</div>
          <div class="info" style="display:block;margin:0">德才兼备、自我驱动、结果导向、敢想敢拼</div>
        </div>
      </div>
    </div>
    <div class="people">
      <Thetit :cn="cn"></Thetit>
      <div class="map">
        <div class="rect down">
          <div class="bgbox">
            <div class="bg"></div>
            <p>选</p>
          </div>
          <div>明确的选拔标准、鼓励内外部推荐、公开公正的内部竞聘</div>
        </div>
        <div>
          <div class="rect right">
            <div class="bgbox">
              <div class="bg"></div>
              <p>留</p>
            </div>
            <div>公平多样的薪酬福利体系、长期和中短期的激励机制、双通道的职业发展机制</div>
          </div>
          <div class="circle_name">
            <div>人才发展体系</div>
          </div>
          <div class="rect left">
            <div class="bgbox">
              <div class="bg"></div>
              <p>育</p>
            </div>
            <div>贴近业务战略的人才培养体系、面向不同人群的培养项目、打造阶梯式的人才队伍</div>
          </div>
        </div>
        <div class="rect top">
          <div class="bgbox">
            <div class="bg"></div>
            <p>用</p>
          </div>
          <div>任人唯才，用人之长、鼓励岗位内部流动和晋升、上级考核与360考核相结合</div>
        </div>
      </div>
      <div class="infos">
        <p>在这里，我们以“同学”称谓，同事之间都亲切地直呼其名。</p>
        <p>在这里，我们崇尚进取、拼搏、创新，化繁琐为简单，努力追求极简和完美。</p>
        <p>在这里，我们纯真、爽朗、开心，用最真诚的心和甜美的笑容去迎接每一天。</p>
        <p>亿车不但提供轻松的办公环境，还设计了丰富的文化活动。</p>
      </div>
    </div>
    <div class="company">
      <Thetit :cn="cn1"></Thetit>
      <div class="infos">
        <p>在3000平米的宽敞写字楼内，亿车开辟了休息区、茶歇区、娱乐区等专区，</p>
        <p>让员工在工作之余得到充分的放松，</p>
        <p>空气净化系统和净水系统遍布在公司的每一个角落，</p>
        <p>让新鲜的空气和水陪伴员工每一天。</p>
        <p>多媒体“武装”的会议室，让开会讨论成为乐趣，让头脑风暴来的更凶猛。</p>
        <p>开放式办公，让彼此沟通更便捷，更顺畅。</p>
      </div>
      <div class="imgbox">
        <img src="~@/common/img/round6.jpg">
        <img src="~@/common/img/round4.jpg">
        <img src="~@/common/img/round5.jpg">
        <img src="~@/common/img/round3.jpg">
        <img src="~@/common/img/round1.jpg">
        <img src="~@/common/img/round2.jpg">
      </div>
    </div>
    <div class="cultrue">
      <Thetit :cn='cn2'></Thetit>
      <div class="infos">
        <p>公司为员工设计了丰富多彩的活动和完善的福利保障</p>
        <p>年度总结大会、每周技术分享会、每天下午自助下午茶，以及节日关怀、出游、部门聚餐等活动，</p>
        <p>丰富多彩的福利计划，是亿车员工团队身心愉悦和成就感的源泉之一。</p>
      </div>

    </div>
    <div class="imgtype">
      <ul>
        <li @click="_changeT(item.key)" :class="item.key == index ? 'active' : ''" v-for="item in list" :key="item.key">{{item.value}}</li>
      </ul>
    </div>
    <div class="main">
      <div v-if="index == item.key" v-for="item in list" :key="item.key" class="box boxname">
        <div>
          <Theimg :id='imgsid[1]' :src='imglist[1]'></Theimg>
        </div>
        <div>
          <Theimg :id='imgsid[2]' :src='imglist[2]'></Theimg>
        </div>
        <div>
          <Theimg :id='imgsid[3]' :src='imglist[3]'></Theimg>
        </div>
        <div>
          <Theimg :id='imgsid[4]' :src='imglist[4]'></Theimg>
        </div>
        <div>
          <Theimg :id='imgsid[5]' :src='imglist[5]'></Theimg>
        </div>
        <div>
          <Theimg :id='imgsid[6]' :src='imglist[6]'></Theimg>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Thetit from '../recomment/title';
import Theimg from './child/upimg';
import { getactType, getCultureList } from '@/api/portal';
import culdefault from '@/common/img/culdefault.jpg';
export default {
  data() {
    return {
      cn: '人才发展体系',
      cn1: '办公环境',
      cn2: '文化活动',
      index: 1,
      li_leng: 0,
      list: [],
      imglist: [],
      imgsid: [],
      time: null, //全局时间变量
      culdefault,
    };
  },
  components: {
    Thetit,
    Theimg,
  },
  methods: {
    //获取活动类型
    _getType() {
      getactType({ action: 'pic.culture.getType' })
        .then(res => {
          this.index = res.data[0].key;
          this._getImg();
          this.list = res.data;
          this.li_leng = this.list.length;
        })
        .catch(err => {});
    },
    //获取活动图片
    _getImg() {
      var _this = this;
      getCultureList({
        action: 'pic.culture.getCultureList',
        type: this.index,
      })
        .then(res => {
          //生成以位置为下标的数组
          var lists = res.data;
          var arr = [];
          var brr = [];
          lists.forEach(function(element, i) {
            arr[element.seat] = element.culture_imges
              ? element.culture_file
              : '';
            brr[element.seat] = element.id;
          });
          _this.imglist = arr;
          _this.imgsid = brr;
        })
        .catch(err => {});
    },
    //修改显示图片类型
    _changeT(index) {
      this.index = index;
      this._getImg();
    },
  },
  mounted() {
    this._getType();
    this._getImg();
  },
};
</script>

<style lang="scss" scoped>
#cultrue {
  .boxname {
    margin-top: -41px;
    margin-bottom: 40px;
  }
  .active::after {
    content: '';
    width: 16px;
    height: 2px;
    background-color: #d1551c;
    position: absolute;
    bottom: -11px;
    left: calc(50% - 8px);
  }
  .main {
    width: 1176px;
    margin: 0 auto;
    text-align: center;
    margin: 0 auto;
    padding-bottom: 56px;
  }
  .cbox {
    width: 1000px;
    margin: 0 auto;
    padding-bottom: 72px;
  }
  .cbox > div {
    display: inline-block;
    vertical-align: top;
  }
  .cbox > div:last-child {
    width: 379px;
    margin-left: 24px;
  }
  .tit {
    font-size: 18px !important;
    color: rgba(0, 0, 0, 0.88);
    font-weight: bold;
    padding: 0 0 16px;
  }
  .info {
    font-size: 14px !important;
    color: #000000;
    opacity: 0.72;
    padding: 0 0 24px;
    font-size: 14px;
    line-height: 1.6;
  }
  .people {
    background-color: #f2f2f2;
    padding: 80px 0;
  }
  .map {
    padding: 56px 0;
    width: 1176px;
    margin: 0 auto;
  }
  .rect,
  .circle_name {
    width: 280px;
    height: 120px;
    box-sizing: border-box;
    padding: 8px 16px;
    background-color: #fff;
    border: 1px solid rgb(221, 225, 227);
  }
  .rect {
    border-radius: 12px;
    box-shadow: -2px 2px 8px 2px #e2e1e1;
  }
  .circle_name {
    border-radius: 80px;
    height: 140px;
    box-shadow: -2px 5px 20px 0px rgba(47, 152, 233, 0.3);
  }
  .map {
    background-image: url('~@/common/img/cul1.png');
    background-repeat: no-repeat;
    background-position: center center;
  }
  .map > div:first-child,
  .map > div:last-child {
    margin: 0 auto;
  }
  .map > div:nth-child(2) {
    font-size: 0;
    // margin: 80px 0;
  }
  .map > div:nth-child(2) > div {
    display: inline-block;
    vertical-align: middle;
    height: 140px;
  }
  // .map > div:nth-child(2) > div:nth-child(2) {
  //   margin: 0 88px;
  // }
  .rect p {
    font-size: 20px;
    color: #2f98e9;
    margin-left: 4px;
  }
  .bgbox {
    padding-bottom: 8px;
    padding-top: 8px;
  }
  .bgbox > div,
  .bgbox p {
    display: inline-block;
    vertical-align: middle;
  }
  .bgbox > div {
    width: 24px;
    height: 24px;
  }
  .down .bgbox > div {
    background-image: url('~@/common/img/cul.png');
    background-position: -86px -13px;
    background-repeat: no-repeat;
  }
  .left .bgbox > div {
    background-image: url('~@/common/img/cul.png');
    background-position: -118px -13px;
    background-repeat: no-repeat;
  }
  .right .bgbox > div {
    background-image: url('~@/common/img/cul.png');
    background-position: -10px center;
    background-repeat: no-repeat;
  }
  .right {
    margin-left: 122px;
  }
  .left {
    margin-left: 48px;
  }
  .circle_name {
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: 40px;
  }
  .top .bgbox > div {
    background-image: url('~@/common/img/cul.png');
    background-position: -48px center;
    background-repeat: no-repeat;
  }
  .rect div {
    font-size: 14px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.72);
  }
  .bg {
    margin-right: 16px;
  }
  .circle_name {
    font-size: 30px;
    color: #2f98e9;
    line-height: 138px;
    text-align: center;
    padding: 0;
    font-weight: 600;
  }
  .box {
    font-size: 0;
  }
  .box > div {
    display: inline-block;
    vertical-align: middle;
  }
  .box > div:nth-child(3n + 2) {
    margin: 0 24px;
  }
  .box > div:nth-child(n + 4) {
    margin-top: 24px;
  }
  .top,
  .down,
  .left,
  .right {
    position: relative;
  }
  .down::before,
  .down::after,
  .top ::before,
  .top ::after,
  .left::before,
  .left::after,
  .right::before,
  .right::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
  }
  .top ::before {
    border-bottom: 10px solid rgb(221, 225, 227);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    top: -10px;
    left: 125px;
  }
  .top ::after {
    border-bottom: 10px solid #fff;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    top: -9px;
    left: 125px;
  }
  .down::before {
    border-top: 10px solid rgb(221, 225, 227);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    bottom: -10px;
    left: 125px;
  }
  .down::after {
    border-top: 10px solid #fff;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    bottom: -9px;
    left: 125px;
  }
  .left::before {
    border-right: 10px solid rgb(221, 225, 227);
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    left: -10px;
    top: 45px;
  }
  .left::after {
    border-right: 10px solid #fff;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    left: -9px;
    top: 45px;
  }
  .right::before {
    border-left: 10px solid rgb(221, 225, 227);
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    right: -10px;
    top: 45px;
  }
  .right::after {
    border-left: 10px solid #fff;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    right: -9px;
    top: 45px;
  }
  .infos {
    text-align: center;
    color: rgba(0, 0, 0, 0.64);
    padding: 40px 0;
    font-size: 14px;
    letter-spacing: 1px;
  }
  .infos p {
    line-height: 2;
  }
  .company {
    padding: 72px 0;
  }
  .imgbox {
    font-size: 0;
    text-align: center;
    margin: 0 auto;
    width: 1176px;
  }
  .imgbox img {
    width: 310px;
    height: 199px;
  }
  .imgbox img:nth-child(2),
  .imgbox img:nth-child(3),
  .imgbox img:nth-child(5),
  .imgbox img:nth-child(6) {
    margin-left: 24px;
    // margin-right: 24px;
  }
  .imgbox img:nth-child(4),
  .imgbox img:nth-child(5),
  .imgbox img:nth-child(6) {
    margin-top: 24px;
  }
}
.tab ul {
  font-size: 0;
  width: 600px;
  margin: 49px auto 96px;
}
.tab ul li {
  display: inline-block;
  vertical-align: middle;
  color: rgba(0, 0, 0, 0.72);
  font-size: 16px;
  position: relative;
  cursor: pointer;
}
.tab ul li:not(:first-child) {
  margin-left: 64px;
}
.tab ul li:not(:first-child)::before {
  content: '';
  position: absolute;
  width: 2px;
  height: 12px;
  background-color: rgba(0, 0, 0, 0.32);
  left: -32px;
  top: 8px;
}
.imgtype {
  margin-top: -41px;
}
.tab ul li:hover {
  color: #d1551c !important;
}
.active {
  color: #d1551c !important;
}
</style>
